module.exports = __webpack_public_path__ + "static/police-terry-4f7c677a71965dfd517a2f3a7f35fe4e.gif";